import React, { Component } from "react";
import { connect } from "react-redux";
import Loading from "./loading";
import { config, msg } from "../../constants";
import UserInfo from "./userInfo";
import { fetchProject } from "../../store/project/projectAction";
import { loginCustomer, registerCustomer } from "../../store/login/loginAction";
import { fetchOrders } from "../../store/orders/ordersAction";
import { Link } from "react-router-dom";
import { setLocale } from "react-redux-i18n";
import { Modal, ModalBody, Spinner } from 'reactstrap';
import axios from "axios";

const locale = require("react-redux-i18n").I18n;
// const Cryptr = require("cryptr");
// const cryptr = new Cryptr(config.appkey);
const fpe = require("node-fpe");
const cipher = fpe({ password: config.appkey });
const jwt = require("jsonwebtoken");

class header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      runFirst: true,
      chkLogin: false,
      chkRegister: false,
      modalIsOpen: false
    }
  }
  componentWillMount() {
    // console.log(localStorage.getItem('user_login'));
  }

  async componentDidMount() {

    let resp = await axios.post(config.apiUrl + "/login/gtkn", {});

    // if (parseInt(resp.data.code) === 200) {
    //   localStorage.setItem('sys_token', resp.data.token);
    // }

    if (localStorage.getItem("project_id") && !this.props.project.project_id) {
      const projectId = cipher.decrypt(localStorage.getItem("project_id"));
      const paramsApi = { project_id: projectId };
      // console.log('fpj 01');
      this.props.fetchProject(paramsApi);
    }
    const access_token = localStorage.getItem("access_token");
    const user_login = localStorage.getItem("user_login");
    //console.log(access_token);
    if (access_token) {
      const userData = jwt.decode(access_token);
      this.setState({
        user: userData,
        user_login: user_login,
        login_name: ((typeof user_login !== 'undefined' && user_login !== '') ? user_login : userData.sub),
      });
    }
    //console.log(this.props);
  }

  componentWillReceiveProps(next) {
    const access_token = localStorage.getItem("access_token");
    const user_login = localStorage.getItem("user_login");
    const userData = jwt.decode(access_token);
    if (access_token && next.project) {
      this.props.loginCustomer({
        project_id: next.project.project_id,
        user_login: user_login,
        login_name: ((typeof user_login !== 'undefined' && user_login !== '') ? user_login : userData.sub),
        display_name: ((typeof userData.profile.display_name !== 'undefined') ? userData.profile.display_name : ''),
        tel: ((typeof userData.profile.trueid !== 'undefined' && typeof userData.profile.trueid.mobile !== 'undefined') ? userData.profile.trueid.mobile : ''),
        email: ((typeof userData.profile.trueid !== 'undefined' && typeof userData.profile.trueid.email !== 'undefined') ? userData.profile.trueid.email : '')
      });
      this.setState({ chkLogin: true });
    }

    if (next.project && next.customerID && this.state.runFirst) {
      //console.log(next.customerID);
      // console.log('fetchOrders 01');
      this.props.fetchOrders({
        project_id: next.project.project_id,
        customer_id: next.customerID
      });
      this.setState({ runFirst: false });
    }
  }
  handleRegisterCustomer = async () => {
    if (!this.props.customerID && this.state.chkLogin && !this.state.chkRegister) {
      this.props.registerCustomer({
        project_id: this.props.project.project_id,
        login_name: this.state.login_name,
        display_name: ((typeof this.state.user.profile.display_name !== 'undefined') ? this.state.user.profile.display_name : ''),
        tel: ((typeof this.state.user.profile.trueid !== 'undefined' && typeof this.state.user.profile.trueid.mobile !== 'undefined') ? this.state.user.profile.trueid.mobile : ''),
        email: ((typeof this.state.user.profile.trueid !== 'undefined' && typeof this.state.user.profile.trueid.email !== 'undefined') ? this.state.user.profile.trueid.email : '')
      });
      this.openModal()
      this.setState({ chkRegister: true });
      await this.props.loginCustomer({
        project_id: this.props.project.project_id,
        login_name: this.state.login_name,
        display_name: ((typeof this.state.user.profile.display_name !== 'undefined') ? this.state.user.profile.display_name : ''),
        tel: ((typeof this.state.user.profile.trueid !== 'undefined' && typeof this.state.user.profile.trueid.mobile !== 'undefined') ? this.state.user.profile.trueid.mobile : ''),
        email: ((typeof this.state.user.profile.trueid !== 'undefined' && typeof this.state.user.profile.trueid.email !== 'undefined') ? this.state.user.profile.trueid.email : '')
      });
      this.closeModal();
    }
  };
  openModal() {
    this.setState({ modalIsOpen: true });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  handleChangLanguage = l => {
    if (this.props.l !== l) {
      this.props.setLang(l);
    }
  };
  HomePage = () => {
    return (
      config.baseUrl + "/shop/" + cipher.encrypt(this.props.project.project_id)
    );
  };
  openHamberger = e => {
    const navMobile = document.getElementsByClassName("mobile")[0];
    var chkHaveOpen = false;
    navMobile.classList.forEach(element => {
      if (element === "mobile--open") {
        chkHaveOpen = true;
      }
    });
    if (chkHaveOpen) {
      navMobile.classList.remove("mobile--open");
    } else {
      navMobile.classList.add("mobile--open");
    }
  };

  logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("expires_in");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_login");
    document.cookie = 'utk=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    window.location = config.logoutUri + encodeURI(config.baseUrl + "/shop/" + cipher.encrypt(this.props.project.project_id))
    return false;
  };

  render() {
    this.handleRegisterCustomer();
    const customStyles = {
      textAlign: 'center',
      top: '40%',
    }
    //console.log(this.props.customerID);
    //console.log(this.props.project);
    const projectStatus = this.props.project.project_status;
    //console.log(projectStatus);
    if (projectStatus !== "A") {
      return (
        <>
          <Loading />
        </>
      );
    }
    const redirectLoginUri = encodeURI(
      config.loginRedirectUri +
      "param=" +
      cipher.encrypt(this.props.project.project_id)
    );
    const loginUrl = config.trueidUrl + "&redirect_uri=" + redirectLoginUri;
    //console.log(loginUrl);
    const redirectLogoutUri = encodeURI(
      config.baseUrl + "/shop/" + cipher.encrypt(this.props.project.project_id)
    );
    const logoutUrl = config.logoutUri + redirectLogoutUri;
    return (
      <>
        <header>
          <nav className="navbar navbar-expand-md navbar-dark fixed-top navbar-top">
            <div className="container">
              <a className="navbar-brand" href={this.HomePage()}>
                <img
                  alt="web"
                  src="/cust/web/images/logo/web@2x.png"
                  className="logo"
                />
              </a>
              <div className="nav-box-right">
                <UserInfo loginName={this.state.login_name} userData={this.state.user} logoutUrl={logoutUrl} />
                <UserCart
                  loginName={this.state.login_name}
                  userData={this.state.user}
                  orders={this.props.orders}
                />
                <Userlogin loginName={this.state.login_name} userData={this.state.user} loginUrl={loginUrl} />

                <div className="box-lag">
                  <div className="switch lag1">
                    <input
                      name="lag"
                      type="radio"
                      value="lag"
                      id="th"
                      defaultChecked={this.props.l === "th"}
                      onClick={() => this.handleChangLanguage("th")}
                    />
                    <label htmlFor="th" className="label-first">
                      <img
                        alt="ic_thai"
                        src="/cust/web/images/icon/ic_thai.png"
                      />
                      <p>THAI</p>
                    </label>
                    <input
                      disabled={true} //FIXME
                      name="lag"
                      type="radio"
                      value="lag"
                      id="en"
                      defaultChecked={this.props.l === "en"}
                      onClick={() => this.handleChangLanguage("en")}
                    />
                    <label htmlFor="en" className="right">
                      <img
                        alt="ic_eng"
                        src="/cust/web/images/icon/ic_eng.png"
                      />
                      <p>ENGLISH</p>
                    </label>
                    <span aria-hidden="true" />
                  </div>
                </div>
                <div className="mobile-nav">
                  <button id="nav-toggle">
                    <span className="menu" onClick={this.openHamberger} />
                  </button>
                </div>
              </div>
            </div>
          </nav>
          <nav className="mobile">
            {this.state.login_name !== undefined ?
              <>
                <div className="box-cart-user">
                  <a
                    className="btn btn-user collapsed"
                    data-toggle="collapse"
                    href="#collapseUser"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    {this.state.login_name} <i className="la la-angle-down" />
                  </a>
                  <div className="collapse" id="collapseUser">
                    <div className="card card-body">
                      <Link to="/register">{locale.t("dataProfile")}</Link>
                    </div>
                  </div>
                </div>
                <div className="box-lag">
                  <div className="switch lag2">
                    <input
                      name="lag-mo"
                      type="radio"
                      value="lag-mo"
                      id="th-mo"
                      defaultChecked={this.props.l === "th"}
                      onClick={() => this.handleChangLanguage("th")}
                    />
                    <label htmlFor="th-mo" className="label-first">
                      <img
                        alt="ic_thai"
                        src="/cust/web/images/icon/ic_thai.png"
                      />
                      <p>THAI</p>
                    </label>
                    <input
                      disabled={true} //FIXME
                      name="radlagio-mo"
                      type="radio"
                      value="lag-mo"
                      id="en-mo"
                      defaultChecked={this.props.l === "en"}
                      onClick={() => this.handleChangLanguage("en")}
                    />
                    <label htmlFor="en-mo" className="right">
                      <img alt="ic_eng" src="/cust/web/images/icon/ic_eng.png" />
                      <p>ENGLISH</p>
                    </label>
                    <span aria-hidden="true" />
                  </div>
                </div>

                <ul>
                  <li className="">
                    <a className="dropdown-item btn-logout" onClick={this.logout} href="#logout" alt="logout">
                      {locale.t("logout")}
                    </a>
                  </li>
                </ul>
              </>
              :
              <>
                <div className="box-lag">
                  <div className="switch lag2">
                    <input
                      name="lag-mo"
                      type="radio"
                      value="lag-mo"
                      id="th-mo"
                      defaultChecked={this.props.l === "th"}
                      onClick={() => this.handleChangLanguage("th")}
                    />
                    <label htmlFor="th-mo" className="label-first">
                      <img
                        alt="ic_thai"
                        src="/cust/web/images/icon/ic_thai.png"
                      />
                      <p>THAI</p>
                    </label>
                    <input
                      disabled={true} //FIXME
                      name="radlagio-mo"
                      type="radio"
                      value="lag-mo"
                      id="en-mo"
                      defaultChecked={this.props.l === "en"}
                      onClick={() => this.handleChangLanguage("en")}
                    />
                    <label htmlFor="en-mo" className="right">
                      <img alt="ic_eng" src="/cust/web/images/icon/ic_eng.png" />
                      <p>ENGLISH</p>
                    </label>
                    <span aria-hidden="true" />
                  </div>
                </div>

                <ul>
                  <li className="">
                    <a className="dropdown-item btn-logout" href={loginUrl}>
                      {locale.t("login")}
                    </a>
                  </li>
                </ul>
              </>
            }
          </nav>
          <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <ModalBody>
              <Spinner color="danger" />
              {'  ' + msg.register}
            </ModalBody>
          </Modal>
        </header>
      </>
    );
  }
}

const UserCart = props => {
  const { loginName, orders } = props;
  // console.log('UserCart');
  // console.log(props);
  if (loginName) {
    return (
      <div className="box-cart-drawer">
        <Link to="/cart" className="btn btn-sm btn-cart-drawer">
          {locale.t("cart")}{" "}
          <span className="noti">
            {orders.length ? "(" + orders.length + ")" : ""}
          </span>
        </Link>
      </div>
    );
  }
  return null;
};

const Userlogin = props => {
  const { loginName, loginUrl } = props;
  // console.log(userData);
  if (!loginName) {
    return (
      <div className="box-logIn">
        <a
          className="btn btn-sm btn-logIn"
          href={loginUrl}
          // target="_blank"
          rel="noopener noreferrer"
        >
          {locale.t("login")}
        </a>
      </div>
    );
  }
  return null;
};

const mapStateToProps = state => ({
  project: state.project.info,
  customerID: state.login.customerID,
  orders: state.orders.items,
  l: state.i18n.locale
});

const setLang = l => dispatch => {
  //setLang: l => {
  return dispatch(setLocale(l));
  //}
};

// const mapDispatchToProps = dispatch => ({
//   setLang: l => {
//     dispatch(setLocale(l));
//   },
//   fetchProject,
//   loginCustomer,
//   fetchOrders
// });

export default connect(
  mapStateToProps,
  {
    fetchProject,
    loginCustomer,
    registerCustomer,
    fetchOrders,
    setLang
  }
)(header);
